import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createReleaseNotesTitle: {
		id: 'project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title',
		defaultMessage: 'Create release notes',
		description: 'Checkbox title',
	},
});
